<template>
  <v-dialog
    v-model="show"
    width="800"
  >
    <v-card>
      <v-card-text class="pt-5">
        <v-alert
          v-if="!showDisclosure"
          prominent
          dense
          dark
          text
          border="start"
          color="primary"
          icon="mdi-account-voice"
        >
          <blockquote class="blockquote">
            "Would you like to set this {{ accountType }} as your Primary Payment Method?
            This means that all future payments for your loan will be charged
            using this payment method."
          </blockquote>
        </v-alert>

        <div v-if="showDisclosure">
          <v-card v-if="step === 1">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <h2 class="talk__off-one_title">
                    <b>Representative:</b>
                  </h2>
                  <blockquote class="blockquote">
                    "I can help set up your recurring loan payment. By authorizing this,
                    you are allowing TBO Bank to electronically withdraw funds from
                    your account as agreed upon."
                  </blockquote>

                  <blockquote
                    v-if="showNextDateNotice"
                    class="blockquote error--text"
                  >
                    "If you enroll in autopay now, it will take effect starting with your
                    following payment due date. Your upcoming immediate payment will still
                    need to be made manually."
                  </blockquote>

                  <div class="talk__off-payment-details">
                    <h3>Please confirm the following details:</h3>

                    <ul>
                      <li>
                        <span>Payment Amount: ${{ recurringAutopayAmount }}</span>
                      </li>
                      <li>
                        <span>Payment Frequency: {{ paymentsFrequency }}</span>
                      </li>
                      <li>
                        <span>First Payment Date: {{ convertDateFormat(firstPaymentDate) }}</span>
                      </li>
                      <li>
                        <span
                          v-if="accountType === 'debit card'"
                        >
                          Debit Card Ending In: {{ accountLast4 }}
                        </span>
                        <span v-else> Bank Account Ending In: {{ accountLast4 }} </span>
                      </li>
                      <li>
                        <span>Final Payment Date: {{ convertDateFormat(finalPaymentDate) }}</span>
                      </li>
                    </ul>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    v-model="electronicDisclosureConsent"
                    :label="`Do you confirm that these details are correct?`"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn
                :disabled="electronicDisclosureConsent === false"
                color="primary"
                :loading="loading"
                @click="nextStep()"
              >
                <span> Continue </span>
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-if="step === 2">
            <v-card-text>
              <v-row>
                <v-col>
                  <h2 class="talk__off-one_title">
                    <b>Representative:</b>
                  </h2>

                  <div class="talk__off-payment-details mt-2">
                    <h3>Under Federal Regulations, we must inform you that:</h3>

                    <ul>
                      <li>
                        <blockquote class="blockquote">
                          "You can cancel this authorization at any time by notifying
                          us at least three business days before your next payment by
                          calling us at 561-462-8527 or emailing us at supportteam@tbobank.com."
                        </blockquote>
                      </li>
                      <li>
                        <blockquote class="blockquote">
                          "A written confirmation of this authorization will be
                          sent to you at {{ customerEmail }}. Please review and
                          keep it for your records."
                        </blockquote>
                      </li>
                      <li>
                        <blockquote class="blockquote">
                          "If your payment amount is different, we will notify
                          you at least 10 business days in advance."
                        </blockquote>
                      </li>
                    </ul>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-checkbox
                    v-model="agreeFederalRegulations"
                    :label="`Do you confirm that these details are correct?`"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                @click="goBack()"
              >
                Back
              </v-btn>

              <v-spacer />

              <v-btn
                :disabled="agreeFederalRegulations === false"
                color="primary"
                :loading="loading"
                @click="nextStep()"
              >
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-if="step === 3">
            <v-card-text>
              <v-row>
                <v-col>
                  <h2 class="talk__off-one_title">
                    <b>Representative:</b>
                  </h2>

                  <div class="talk__off-payment-details mt-2">
                    <p>Click on the button to sent the EFT Document and Create the Autopay</p>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                @click="goBack()"
              >
                Back
              </v-btn>

              <v-spacer />

              <v-btn
                :disabled="sendingDocument"
                color="primary"
                :loading="sendingDocument"
                @click="enableRecurringPayment"
              >
                Send EFT Document and Create Autopay
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
        <div
          v-if="disclosuresSent && amortizationSent"
          class="row mt-3 mb-3"
        >
          <div class="col-12">
            <v-alert
              v-if="disclosuresSent && amortizationSent"
              prominent
              dense
              dark
              text
              border="start"
              color="primary"
              icon="mdi-account-voice"
            >
              <blockquote class="blockquote">
                Do you acknowledge and agree to the Electronic Payment Disclosure?
              </blockquote>
            </v-alert>
            <div class="text-center mb-2">
              If YES
            </div>
            <v-btn
              class="primary"
              width="100%"
              @click="$emit('use-for-future-payments')"
            >
              add this {{ accountType }} as the Primary Method
            </v-btn>
            <div class="text-center mb-2 mt-2">
              If NO
            </div>
            <v-btn
              class="mb-2"
              width="100%"
              @click="$emit('no-future-payments')"
            >
              add this {{ accountType }}, but do not set as Primary Method
            </v-btn>
            <v-btn
              width="100%"
              @click="onClose"
            >
              do not add this {{ accountType }}
            </v-btn>
          </div>
        </div>
      </v-card-text>

      <v-card-actions
        v-if="!showDisclosure"
        class="pb-10"
      >
        <v-spacer />
        <v-btn
          text
          @click.stop="$emit('no-future-payments')"
        >
          no
        </v-btn>
        <v-btn
          v-if="!loading"
          color="primary"
          dark
          :disabled="disclosureDialog"
          @click.stop="handleYes()"
        >
          yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { DateTime } from 'luxon';

export default {
  props: {
    value: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
    accountType: {
      type: String,
      required: true,
    },
    ticket: {
      type: Object,
      required: true,
    },
    paymentProfile: {
      type: Object,
      required: true,
    },
    autopayType: {
      type: String,
      required: false,
      default: 'normal',
      validator: (value) => ['normal', 'settlement'].includes(value),
    },
  },
  data() {
    return {
      disclosureDialog: false,
      amortizationDialog: false,
      showDisclosure: false,
      autopay: null,
      payment: null,
      electronicDisclosureConsent: false,
      agreeFederalRegulations: false,
      sendingDocument: false,
      step: 1,
    };
  },
  computed: {
    ...mapState('loanProCustomer', ['paymentProfiles', 'customer']),
    ...mapState('settlement', ['disclosuresSent']),
    ...mapState('loanProLoan', ['amortizationSent', 'activeLoan', 'paymentSchedules', 'nextAutopayPaymentDate']),
    ...mapState('autopays', ['recurring']),
    ...mapGetters('loanProLoan', ['nextPaymentInfo', 'recurringAutopays', 'nextPaymentDueDate']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    loanDisplayId() {
      return this.ticket?.active_loan?.display_id ?? '';
    },

    accountLast4() {
      return this.paymentProfile?.title?.slice(-4) ?? '';
    },

    hasAutopay() {
      return this.recurringAutopays.length > 0;
    },

    showNextDateNotice() {
      if (this.hasAutopay) {
        return false;
      }

      if (!this.nextPaymentDueDate || !this.nextAutopayPaymentDate?.paymentTime) {
        return false;
      }

      const paymentDate = DateTime.fromFormat(this.nextPaymentDueDate, 'yyyy-MM-dd').startOf('day');
      const autopayDate = DateTime.fromFormat(this.nextAutopayPaymentDate.dateLimit, 'yyyy-MM-dd').startOf('day');

      // eslint-disable-next-line max-len
      return autopayDate.valueOf() >= paymentDate.valueOf();
    },

    firstPaymentDate() {
      if (this.hasAutopay) {
        return this.nextPaymentInfo?.paymentDate ?? '';
      }

      return this.nextAutopayPaymentDate?.paymentTime ?? '';
    },

    recurringAutopayAmount() {
      return this.nextPaymentInfo?.paymentAmount ?? 0;
    },

    customerEmail() {
      return this.customer?.email ?? '';
    },

    customerName() {
      return `${this.customer?.first_name} ${this.customer?.last_name}` ?? '';
    },

    bankAccountTypeText() {
      return this.paymentProfile?.type === 'paymentAccount.type.checking' ? 'Bank Account' : 'Debit Card';
    },

    paymentsFrequency() {
      const paymentsFrequencies = {
        'loan.frequency.weekly': 'Weekly',
        'loan.frequency.biWeekly': 'Bi-Weekly',
        'loan.frequency.semiMonthly': 'Semi-Monthly',
        'loan.frequency.monthly': 'Monthly',
      };

      return paymentsFrequencies[this.activeLoan?.loan_setup?.payment_frequency] ?? '';
    },

    finalPaymentDate() {
      if (!this.activeLoan) {
        return null;
      }

      return this.activeLoan?.current_status?.final_payment_date ?? null;
    },
  },
  watch: {
    show(newVal) {
      if (newVal === true) {
        this.disclosuresNotSent();
        this.showDisclosure = false;
      }
    },
  },
  methods: {
    ...mapActions('settlement', ['disclosuresNotSent']),
    ...mapActions('autopays', ['updateAutopayPayment', 'createLoanRecurringAutopay', 'updateSelectedAutopayPayment']),
    ...mapActions('loanProLoan', ['sendAmortization']),

    formatDate(dateString) {
      return DateTime.fromFormat(dateString, 'yyyy-MM-dd HH:mm:ss').toFormat('MM/dd/yyyy');
    },

    async enableRecurringPayment() {
      this.sendingDocument = true;
      await this.sendAmortization({
        loanId: this.activeLoan.id,
        ticketId: this.$route.params.id,
        name: this.customerName,
        bankAccountType: this.bankAccountTypeText,
        accountLast4: this.accountLast4,
        loanDisplayId: this.loanDisplayId,
        routingNumber: this.paymentProfile?.checking_account?.routing_number ?? '',
        firstPaymentDate: this.convertDateFormat(this.firstPaymentDate),
      });

      this.sendingDocument = false;

      this.$emit('use-for-future-payments');
    },

    goBack() {
      this.step -= 1;
    },

    nextStep() {
      this.step += 1;
    },

    convertDateFormat(date) {
      if (!date) return null;

      let parsedDate = DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss');

      if (!parsedDate.isValid) {
        // Try the second format if the first one fails
        parsedDate = DateTime.fromFormat(date, 'yyyy-MM-dd');
      }

      return parsedDate.isValid ? parsedDate.toFormat('MM/dd/yyyy') : null;
    },

    handleYes() {
      this.showDisclosure = true;
    },

    onClose() {
      this.showDisclosure = false;
      this.show = false;
    },

    getAutopay() {
      return this.$axios
        .post('api/v1/support/ticket/autopay/find', {
          ticketId: this.$route.params.id,
          loanId: this.ticket.active_loan.id,
        })
        .then((res) => {
          this.autopay = res.data.autopay;
          this.payment = res.data.payment;
        });
    },

    revokeAutopay() {
      this.confirmModal = false;
      this.loadingModel = true;
      return this.$axios
        .post('api/v1/support/ticket/autopay/revoke', {
          ticketId: this.$route.params.id,
          loanId: this.ticket.active_loan.id,
          autopayId: this.autopay.id,
          paymentId: this.payment ? this.payment.id : undefined,
        })
        .then(() => {
          this.setNotification({
            message: 'The autopay was revoked successfully.',
            color: 'green',
          });
        });
    },
  },
};
</script>
